import React, { lazy, Suspense, FC, useState } from 'react';
import ErrorBoundary from '../../ErrorBoundary/ErrorBoundary';
import { FullScreenSpinner } from '../../components/shared/Spinner';

import { Layers } from '../../components/HyperPersonalizeSection';

import './index.scss';

const getSuspense = (ComponentRef: FC):JSX.Element => {
  return (
    <Suspense fallback={<FullScreenSpinner />}>
      <ComponentRef />
    </Suspense>
  );
}

const HyperPersonlizeLayers: FC<any> = () => {

  const SuspenseComponent = () => {
    return (
      <>
        <div className="hyper-personalize-layers-wrap">
          <div className="flex h-100">
            <Layers />
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="aiquire-homepage-wrapper">
      <ErrorBoundary>
        {getSuspense(SuspenseComponent)}
      </ErrorBoundary>
    </div>
  );
};

export default HyperPersonlizeLayers;

